export type LatLon = { lat: number; lon: number };
export type Bounds = { north: number; south: number; east: number; west: number };

/** Distance en kilomètres entre deux points (formule de haversine). */
export function haversineKm(a: LatLon, b: LatLon): number {
  const R = 6371;
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lon - a.lon);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

/** Rayon (km) du centre du viewport vers son coin nord-est (≈ demi-diagonale). */
export function viewportRadiusKm(center: LatLon, bounds: Bounds): number {
  return haversineKm(center, { lat: bounds.north, lon: bounds.east });
}
